import { render, staticRenderFns } from "./ts_rb.vue?vue&type=template&id=3c108d32&"
import script from "./ts_rb.vue?vue&type=script&lang=js&"
export * from "./ts_rb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports